import React from "react";
import { useNavigate } from "react-router-dom";
import { getNewsLetterGroupData } from "../../api/getNewsLetterGroupData";
import { NewsLetterGroup } from "../../models/newslettergroup.model";
import CreateListModal from "../../components/newsletter/modals/CreateListModal";
import { responseHero } from "../../utils/axiosInterceptor";
import { toast } from "react-toastify";

export default function NewsLetterManagerList() {
    const [newsLetterGroupList, setNewsLetterGroupList] = React.useState<NewsLetterGroup[]>([]);
    const [selectedGroupList, setSelectedGroupList] = React.useState<NewsLetterGroup>();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        getNewsLetterGroupData()
            .then((response) => {
                setNewsLetterGroupList(response);
                const foundSelected = response.find((entity) => entity.selected);
                setSelectedGroupList(foundSelected);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const handleOptionSelection = (option: string) => {
        const selectedGroup = newsLetterGroupList.find((entity) => entity.name === option);
        setSelectedGroupList(selectedGroup);
    };

    const handleRedirect = () => {
        if (!selectedGroupList) return;
        navigate(`/newslettersubscriptionhandling/${selectedGroupList.id}`, {
            state: { name: selectedGroupList.name },
        });
    };

    const handleSelection = async (id: number | undefined) => {
        if(!id) return;

        await responseHero.get(`${process.env.REACT_APP_API_URL}/selectnewslettergroup/${id}`, {
        }).then((response) => {
            toast.success("Sikeresen kiválasztottad a levelezőlistát!");

            navigate(`/newsletter`);

        }).catch(error => {
            console.error(error.response.data);
            toast.error("Hiba a lista kiválasztása közben!")
        });

    };

    const handleCreateList = async (newListName: string) => {
        await responseHero.post(`${process.env.REACT_APP_API_URL}/newslettergroup`, {
            name: newListName
        }).then((response) => {
            
            
            navigate(`/newslettersubscriptionhandling/${response.data.id}`, {
                state: { name: response.data.name },
            });

            toast.success("Sikeresen létrehoztad a levelezőlistát!")
        }).catch(error => {
            console.error(error.response.data);
            toast.error("Hiba a lista létrehozása közben!")
        });
    };

    return (
        <div className="m-5 p-3 max-w-md mx-auto">
            <div className="flex flex-col space-y-4">
                <select
                    value={selectedGroupList?.name || 'Nincs kiválasztva'}
                    onChange={(e) => handleOptionSelection(e.target.value)}
                    className="w-full bg-dark-blue text-white px-3 py-2 rounded-lg shadow-md"
                >
                    <option disabled value={"Nincs kiválasztva"}>
                        Nincs kiválasztva
                    </option>
                    {newsLetterGroupList.map((entity, index) => (
                        <option value={entity.name} key={index}>
                            {entity.name}
                        </option>
                    ))}
                </select>

                <button
                    onClick={handleRedirect}
                    disabled={!selectedGroupList}
                    className="px-4 py-2 bg-brown text-white rounded hover:bg-dark-brown"
                >
                    Résztvevők megtekintése
                </button>

                <button
                    onClick={() => handleSelection(selectedGroupList?.id)}
                    className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                    Kiválasztás hírlevélküldésre
                </button>

                <button
                    onClick={() => setIsModalOpen(true)}
                    className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                    Új lista létrehozása
                </button>
            </div>

            <CreateListModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onCreate={handleCreateList}
            />
        </div>
    );
}
